import Vue from "vue";
import VueRouter from "vue-router";
import Main from "../views/main.vue"
import Home from "../views/Home.vue";
import HomeNew from "../views/Home_new.vue";
import Anylasis from "../views/anylasis.vue";
import Maps from "../views/maps.vue";
import Alerts from "../views/alerts.vue";
import LineList from "../views/lineList.vue";
import Login from "../views/login.vue";
import Upload from "../views/Upload.vue";
import userManagement from "../views/userManagement.vue";
import Pathway from "../views/Pathway.vue";

Vue.use(VueRouter);
function guard(to, from, next){
  //console.log(to);
  if(sessionStorage.getItem("userData") != null) {
    // or however you store your logged in state
    //console.log(to);
    next(); // allow to enter route
  } else{
    next('/'); // go to '/login';
  }
}
const routes = [
  {
    path: '',
    name: 'login',
    component: Login,
  },
  {
    path: "/home",
    beforeEnter: guard,
    component: Main,
    children: [
      {
        path: '',
        name: 'default',
        component: HomeNew,
      },
      {
        path: '/overview',
        name: 'overview',
        component: HomeNew,
      },
      {
        path: '/anylasis',
        name: 'anylasis',
        component: Anylasis,
      },
      {
        path: "/maps",
        name: "maps",
        component: Maps
      },
      {
        path: "/alerts",
        name: "alerts",
        component: Alerts
      },
      {
        path: "/lineList",
        name: "lineList",
        component: LineList
      },
      {
        path: "/upload",
        name: "upload",
        component: Upload
      },
      {
        path: "/upload",
        name: "upload",
        component: Upload
      },
      {
        path: "/pathway",
        name: "pathway",
        component: Pathway
      },
    ]
  },
  {
    path: "/about",
    name: "about",
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/About.vue")
  }
];

const router = new VueRouter({
  // mode: "history",
  base: process.env.BASE_URL,
  routes
});

export default router;
